export default function setTransition(duration, byController) {
  var swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}


//////////////////
// WEBPACK FOOTER
// ./~/swiper/esm/components/core/transition/setTransition.js
// module id = 746
// module chunks = 169